// extracted by mini-css-extract-plugin
export default {"ProgressStepsContainer":"ClientProgressDashboard_ProgressStepsContainer__ZGUds","ProgressStepLabel":"ClientProgressDashboard_ProgressStepLabel__R+sTl"};